<div class="modal fade show d-block"
     tabindex="-1"
     style="background: rgba(0,0,0,0.5)"
     *ngIf="config">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header border-0 text-center justify-content-center">
        <h1 class="modal-title w-100">
          <i *ngIf="config?.modal_color_variant === 'danger'" class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>
          <i *ngIf="config?.modal_color_variant === 'success'" class="fa fa-check-square-o text-success" aria-hidden="true"></i>
          <i *ngIf="config?.modal_color_variant === 'warning'" class="fa fa-exclamation-circle text-warning" aria-hidden="true"></i>
          <i *ngIf="config?.modal_color_variant === 'info'" class="fa fa-info-circle text-info" aria-hidden="true"></i>
          <i *ngIf="config?.modal_color_variant === 'primary'" class="fa fa-bullseye text-primary" aria-hidden="true"></i>
          <i *ngIf="config?.modal_color_variant === 'secondary'" class="fa fa-circle-o text-secondary" aria-hidden="true"></i>
          <i *ngIf="config?.modal_color_variant === 'dark'" class="fa fa-moon-o text-dark" aria-hidden="true"></i>
          <i *ngIf="config?.modal_color_variant === 'light'" class="fa fa-sun-o text-light border rounded-circle" aria-hidden="true"></i>
          {{ config.modal_header_html }}
        </h1>
        <button type="button" class="btn-close" style="border: 3px solid black; border-radius: 2em; margin-right: -3px; margin-bottom: 15px;" (click)="close()"></button>
      </div>

      <div class="modal-body text-center">
        <ul class="list-group">
          <li class="list-group-item"
              [ngClass]="{
                'list-group-item-danger': config?.modal_color_variant === 'danger',
                'list-group-item-success': config?.modal_color_variant === 'success',
                'list-group-item-warning': config?.modal_color_variant === 'warning',
                'list-group-item-info': config?.modal_color_variant === 'info',
                'list-group-item-primary': config?.modal_color_variant === 'primary',
                'list-group-item-secondary': config?.modal_color_variant === 'secondary',
                'list-group-item-dark': config?.modal_color_variant === 'dark',
                'list-group-item-light': config?.modal_color_variant === 'light'
              }"
              [innerHTML]="config?.modal_body_html">
          </li>
        </ul>
      </div>

      <div class="modal-footer mx-auto border-0">
        <button class="btn"
                [ngClass]="{
                  'btn-danger': config?.modal_color_variant === 'danger',
                  'btn-success': config?.modal_color_variant === 'success',
                  'btn-warning': config?.modal_color_variant === 'warning',
                  'btn-info': config?.modal_color_variant === 'info',
                  'btn-primary': config?.modal_color_variant === 'primary',
                  'btn-secondary': config?.modal_color_variant === 'secondary',
                  'btn-dark': config?.modal_color_variant === 'dark',
                  'btn-light': config?.modal_color_variant === 'light'
                }"
                (click)="close()"
        >
          {{ 'BOOTSTRAP.MODAL.CLOSE' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>
